import { render } from "./LogoutView.vue?vue&type=template&id=d4f6305a&scoped=true&ts=true"
import script from "./LogoutView.vue?vue&type=script&lang=ts"
export * from "./LogoutView.vue?vue&type=script&lang=ts"

import "./LogoutView.vue?vue&type=style&index=0&id=d4f6305a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f6305a"]])

export default __exports__